var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWhatsapp = function SvgWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#whatsapp_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.27 20.862h-.003a8.57 8.57 0 0 1-4.095-1.043L3.629 21.01l1.216-4.438A8.567 8.567 0 0 1 16.557 4.875a8.569 8.569 0 0 1-4.287 15.987"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#whatsapp_svg__b)",
    d: "M23.988 5.956a13 13 0 0 0-.124-1.538 5.2 5.2 0 0 0-.435-1.308 4.62 4.62 0 0 0-2.033-2.034 5.2 5.2 0 0 0-1.3-.434 13 13 0 0 0-1.55-.126c-.22-.009-.504-.012-.636-.012L6.092.5c-.132 0-.416.004-.636.012q-.772.015-1.538.124a5.2 5.2 0 0 0-1.308.435A4.63 4.63 0 0 0 .576 3.104a5.2 5.2 0 0 0-.434 1.3 13 13 0 0 0-.128 1.55c-.007.22-.012.504-.012.636L0 18.408c0 .132.004.416.012.636q.015.772.124 1.538c.086.454.232.893.435 1.308a4.63 4.63 0 0 0 2.033 2.034c.412.202.849.348 1.3.434q.77.11 1.55.127c.22.008.504.012.636.012l11.818.002c.132 0 .416-.004.636-.012q.772-.015 1.538-.124a5.2 5.2 0 0 0 1.308-.435 4.63 4.63 0 0 0 2.035-2.033c.202-.412.348-.85.435-1.3q.11-.77.127-1.55c.007-.22.012-.504.012-.636L24 6.592c0-.132-.004-.416-.012-.636M12.26 20.85h-.003a8.55 8.55 0 0 1-4.089-1.042l-4.536 1.19 1.215-4.433a8.556 8.556 0 1 1 7.413 4.285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#whatsapp_svg__c)",
    d: "M12.263 5.181a7.112 7.112 0 0 0-6.028 10.892l.17.268-.72 2.624 2.692-.706.26.154a7.1 7.1 0 0 0 3.619.99h.003a7.112 7.112 0 0 0 .003-14.223zm4.18 10.164a2.2 2.2 0 0 1-1.442 1.017c-.449.077-.91.048-1.346-.084q-.621-.195-1.218-.451A9.53 9.53 0 0 1 8.785 12.6a4.16 4.16 0 0 1-.873-2.21 2.4 2.4 0 0 1 .749-1.783.79.79 0 0 1 .57-.267c.141 0 .284 0 .409.007.132.006.307-.05.48.367.18.427.607 1.48.66 1.586a.4.4 0 0 1 .018.375 1.5 1.5 0 0 1-.214.356c-.108.125-.224.279-.32.375-.108.106-.219.222-.095.435a6.4 6.4 0 0 0 1.19 1.481c.506.451 1.088.81 1.719 1.06.213.109.338.09.463-.053s.534-.624.677-.838.284-.177.48-.107c.195.071 1.248.588 1.461.697.214.107.357.16.41.248.058.344.015.697-.125 1.016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsapp_svg__b",
    x1: 12,
    x2: 12,
    y1: 24.499,
    y2: 0.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "whatsapp_svg__c",
    x1: 12.26,
    x2: 12.26,
    y1: 19.404,
    y2: 5.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "whatsapp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h24v24H0z"
  })))));
};
export default SvgWhatsapp;